// Module
var code = "<div class=\"t-popout c-popout c-popout--thin c-popout--basicList\">\n    <div ng-repeat=\"trigger in ::context.triggers\" ng-bind=\"trigger.title\"></div>\n</div>\n";
// Exports
module.exports = code;